import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-buyers-list',
  templateUrl: './buyers-list.component.html',
  styleUrls: ['./buyers-list.component.css']
})
export class BuyersListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
